import axios from "axios";
import { REWARDS_WEB_URL } from "./api";
import { authorizationHelper } from "../common/helpers";

export function getAll(page, filter) {
  const params = {
    page,
    filter,
  };

  return axios.get(REWARDS_WEB_URL, {
    params,
    headers: { Authorization: authorizationHelper.getAuthorizationToken() },
  });
}

export function claim(reward_id, employee_id) {
  const url = `${REWARDS_WEB_URL}/claim/${reward_id}`,
    params = {
      employee_id,
    };

  return axios.put(url, params, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() },
  });
}

export function getCurrentGift() {
  const url = `${REWARDS_WEB_URL}/currentGift`;

  return axios.get(url, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() },
  });
}

export function getServices() {
  return axios.get(REWARDS_WEB_URL, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() },
  });
}

export function setCurrentGift(service_id) {
  const url = REWARDS_WEB_URL + "/currentGift",
    params = {
      service_id,
    };
  return axios.put(url, params, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() },
  });
}



// WEBPACK FOOTER //
// ./src/service/reward.js